<template>
    <Modal
        :opened="!!modal.title"
        :dissmisable="!modal.blocking"
        class="TheModal"
        @close="handleDismiss()"
    >
        <template slot="header">
            <WText
                typo="h3"
                align="center"
                class="Title"
            >
                {{ modal.title }}
            </WText>
        </template>
        <template slot="body">
            <WText
                typo="p"
                align="center"
                :class="(modal.actions || []).length ? 'NoMargin' : 'WithMargin'"
            >
                {{ modal.text }}
            </WText>
        </template>
        <template
            v-if="(modal.actions || []).length"
            slot="footer"
        >
            <div class="Footer">
                <WButton
                    v-for="(btn, index) in modal.actions"
                    :key="index"
                    :color="btn.color"
                    class="Btn"
                    @click="handleModalActionAndDismiss(btn.action)"
                >
                    {{ btn.text }}
                </WButton>
            </div>
        </template>
    </Modal>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import Modal from '../Modal/Modal.vue'

export default {
    name: 'TheModal',
    components: { Modal },
    computed: {
        ...mapState({
            modal: state => state.notification.modal,
        }),
    },
    methods: {
        ...mapMutations({
            clean: 'notification/CLEAN_MODAL',
        }),
        handleDismiss () {
            const { callback } = this.modal || {}
            callback && callback()
            this.clean()
        },
        handleModalActionAndDismiss (action) {
            this.handleDismiss()
            action && action()
        },
    },
}
</script>

<style scoped lang="scss">
.TheModal {
	.Title {
		margin-bottom: 0px;
	}
	.Nomargin {
		margin-bottom: 0px;
	}
	.WithMargin {
		margin-bottom: 15px;
	}
}
.Footer {
    display: flex;
    align-items: center;
    justify-content: center;
}

.Btn {
    margin: 0 7.5px;
}

</style>
